import * as React from "react";
import type { SVGProps } from "react";
const SvgVisa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={21}
    viewBox="0 0 32 21"
    {...props}
  >
    <path
      fill="#0E4595"
      fillRule="evenodd"
      d="M0 3.913A3.413 3.413 0 0 1 3.413.5h25.174A3.413 3.413 0 0 1 32 3.913v13.174a3.413 3.413 0 0 1-3.413 3.413H3.413A3.413 3.413 0 0 1 0 17.087z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m11.688 14.692 1.401-8.312h2.242l-1.403 8.312zM22.027 6.56l-.304 1.801-.2-.096a4.1 4.1 0 0 0-1.679-.318c-.877 0-1.283.37-1.283.715-.005.39.474.646 1.258 1.03 1.293.594 1.89 1.313 1.882 2.26-.018 1.725-1.547 2.84-3.903 2.84-1.006-.011-1.974-.212-2.497-.444l.314-1.861.289.132c.736.31 1.213.436 2.11.436.644 0 1.336-.254 1.341-.812.004-.363-.289-.623-1.162-1.03-.85-.398-1.976-1.065-1.964-2.26.014-1.615 1.574-2.742 3.789-2.742.869 0 1.565.18 2.009.349m5.768-.18 1.814 8.308h-2.08s-.205-.955-.272-1.246l-2.871-.003c-.087.224-.472 1.249-.472 1.249H21.56l3.33-7.618c.235-.541.636-.69 1.173-.69zm-2.748 5.368h1.86l-.518-2.4-.152-.717c-.113.312-.31.816-.297.793zM9.785 6.38h2.374L8.63 14.676l-2.371.003-2.007-7.27c1.423.72 2.696 2.16 3.104 3.487l.234 1.152z"
      clipRule="evenodd"
    />
    <path
      fill="#F2AE14"
      fillRule="evenodd"
      d="M5.542 6.38H1.927l-.029.173c2.813.688 4.673 2.35 5.446 4.348l-.786-3.82c-.136-.526-.53-.683-1.016-.701"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVisa;
